import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import './MyResume.css';
import { useHistory } from 'react-router';
import resume from '../../../images/resume.pdf';

const MyResume = () => {
    const history = useHistory();
    return (
        <div id="my-resume" className="App">
            <div className="container-about resume-background">
                <div className="center container">
                    <div className="relative-position">
                        <h1 className="h1-sec">My Resume</h1>
                        <hr className="hr-sec" />
                    </div>
                    <br />
                    <br />
                    <br />
                    <Button onClick={() => history.push('/resume')} variant="outline-dark btn-border full-view-btn">
                        SEE FULL VIEW
                        <FontAwesomeIcon className="icon-color custom-icon ml-2" icon={faLongArrowAltRight} />
                    </Button>
                    <br />
                    <Button href={resume} variant="outline-dark btn-border" download>
                        DOWNLOAD RESUME
                        <FontAwesomeIcon className="icon-color custom-icon ml-2" icon={faDownload} />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default MyResume;